const MainPageLoader = () => {
    return (
        <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
            <div className="text-center">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
    );
}

export default MainPageLoader;
